import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { token } = useParams();
  
  useEffect(() => {
    // Проверяем, есть ли токен в параметрах URL
    if (!token) {
      setError('Недійсне посилання для скидання паролю');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Паролі не співпадають');
      return;
    }
    try {
      const response = await axios.post('https://bank2.daolog.net/reset-password', {
        token,
        password
      });
      setMessage(response.data.message);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Сталася помилка');
    }
  };

  return (
    <div style={{ 
      marginTop: "120px", 
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <h1>Встановлення нового паролю</h1>
      <div className="container-about" style={{
        width: "80%",
        maxWidth: "400px",
        margin: "0 auto"
      }}>
        
        {token ? (
          <form onSubmit={handleSubmit} style={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center" 
          }}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Новий пароль"
              required
              className="input-stl"
              style={{ backgroundColor: "#e6f2ff", width: "100%", padding: "10px", margin: "10px 0", borderRadius: "5px", border: "1px solid #ccc", textAlign: "center" }}
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Підтвердіть пароль"
              required
              className="input-stl"
              style={{ backgroundColor: "#e6f2ff", width: "100%", padding: "10px", margin: "10px 0", borderRadius: "5px", border: "1px solid #ccc", textAlign: "center" }}
            />
            <button type="submit" style={{marginTop: "10px"}} className="download-button">Зберегти</button>
          </form>
        ) : (
          <p style={{ color: "red" }}>Недійсне посилання для скидання паролю</p>
        )}
        {message && <p style={{ color: "green" }}>{message}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
}

export default ResetPassword;